/* eslint-disable import/prefer-default-export */
export const selectActiveTab = (state) => state.project?.activeTab;
export const selectProjectParameters = (state) => state.project?.parameters;